import { render, staticRenderFns } from "./ContactSelector.vue?vue&type=template&id=404aebf4&scoped=true&"
import script from "./ContactSelector.vue?vue&type=script&lang=js&"
export * from "./ContactSelector.vue?vue&type=script&lang=js&"
import style0 from "./ContactSelector.vue?vue&type=style&index=0&id=404aebf4&scoped=true&lang=scss&"
import style1 from "./ContactSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404aebf4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404aebf4')) {
      api.createRecord('404aebf4', component.options)
    } else {
      api.reload('404aebf4', component.options)
    }
    module.hot.accept("./ContactSelector.vue?vue&type=template&id=404aebf4&scoped=true&", function () {
      api.rerender('404aebf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/ContactSelector.vue"
export default component.exports